import sliderModule from './swiper/sliders.js';

const {
    sliders,
    slidersResize,
    slidersHero,
    slidersLine,
    slidersThumb,
    sliderDis
} = sliderModule;

// Init
function init() {
    const sliderDefault = document.querySelectorAll('[data-slider="default"]');
    sliderDefault.forEach((el) => {
        sliders(el);
    });

    const sliderHero = document.querySelectorAll('[data-slider="hero"]');
    sliderHero.forEach((el) => {
        slidersHero(el);
    });

    // const sliderResize = document.querySelectorAll('[data-slider="resize"]');
    // sliderResize.forEach((el) => {
    //     slidersResize(el, {
    //         breakpoint: 681
    //     });
    // });

    const sliderResponsibly = document.querySelectorAll('[data-slider="responsibly"]');
    sliderResponsibly.forEach((el) => {
        sliders(el);
    });
    const sliderAwads = document.querySelectorAll('[data-slider="awards"]');
    sliderAwads.forEach((el) => {
        sliders(el);
    });
    const sliderCerf = document.querySelectorAll('[data-slider="certification"]');
    sliderCerf.forEach((el) => {
        sliders(el);
    });
    const sliderLine = document.querySelectorAll('[data-slider="line"]');
    sliderLine.forEach((el) => {
        slidersLine(el);
    });

    const sliderThumb = document.querySelectorAll('[data-slider="thumb"]');
    sliderThumb.forEach((el) => {
        slidersThumb(el);
    });

    const techWidget = [...document.querySelectorAll('[data-slider="stages"]')];
    techWidget.forEach((item) => sliderDis(item, {
        breakpoint          : '767px',
        slidesPerView       : 'auto',
        loop                : false,
        watchSlidesProgress : true
    }));
}

(function () {
    init();
}());
